module.exports = __webpack_public_path__ + "img/icon_crown_loop.2cbb05cf.gif";